import {Button, Modal} from "react-bootstrap";
import React from "react";
import * as PropTypes from "prop-types";

const QbmModal = ({show, title, children, onClose, onHide, ...props}) => {
    return (
        <Modal show={show}
               keyboard={true}
               onHide={onHide}
        >
            <div className="create-dialog-modal-content__header">
                <div className="create-dialog-modal-content__title">{title}</div>
                <div onClick={onClose} className={'create-dialog-modal-content__close'} />
            </div>

            <div className="create-dialog-modal-content__body">
                {children}
            </div>
        </Modal>
    )
}
QbmModal.propTypes = {
    show: PropTypes.bool,
    title: PropTypes.string,
    onClose: PropTypes.func,
    onHide: PropTypes.func,

};

export default QbmModal;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/modals/common/QbmModal.js